// extracted by mini-css-extract-plugin
module.exports = {"textarea-container":"v1V80","textarea-suffix":"_96uNh","textarea":"KqF7w","resize-none":"C0L7+"};